import { useCallback, useEffect } from "react";

export function useFullscreen(
    ref: React.RefObject<HTMLElement>,
    enabled: boolean,
    options?: { onClose?: () => void }
) {
    const requestFullscreen = useCallback(() => {
        if (ref.current && ref.current.requestFullscreen) {
            ref.current.requestFullscreen();
        }
    }, [ref]);

    const exitFullscreen = useCallback(() => {
        if (document.fullscreenElement) {
            document.exitFullscreen();
            options?.onClose?.();
        }
    }, [options]);

    // Следим за enabled и вызываем request/exit по необходимости
    useEffect(() => {
        if (enabled) {
            requestFullscreen();
        } else {
            exitFullscreen();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enabled]);

    // Обработчик выхода из полноэкранного режима (например, по Esc)
    useEffect(() => {
        function handleFullscreenChange() {
            if (!document.fullscreenElement && enabled) {
                options?.onClose?.();
            }
        }
        document.addEventListener("fullscreenchange", handleFullscreenChange);
        return () => {
            document.removeEventListener("fullscreenchange", handleFullscreenChange);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enabled, options]);

    return { requestFullscreen, exitFullscreen };
}